import React from 'react'
import { Box, Text, Image, Heading } from 'grommet'
import styled from 'styled-components'
import {
  Close,
  History,
  Volume,
  VolumeMute,
  Hide,
  Refresh,
} from 'grommet-icons'
import Measure from 'react-measure'
import ActionButton from './ActionButton'
import AllResults from './AllResults'
import Title from './Title'
import Confetti from './Confetti'

import LogoImage from '../../images/Picker-Wheel-Logo-Small.png'

const LinkUrl = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: inherit;
`

// const GlobalStyle = createGlobalStyle`
//   .adthrive-comscore.adthrive-footer-message {
//     display: none;
//   }
//   .adthrive-ad.adthrive-footer.adthrive-footer-1.adthrive-ad-cls.adthrive-sticky {
//     display: none;
//   }
// `

const Container = styled(Box)`
  width: 100%;
  height: 100vh;
  color: ${props => props.textColor};
  /* @media (max-width: 1023px) {
    height: calc(100vh - 1.6rem);
  }
  @media (max-width: 465px) {
    height: 100%;
  } */
  /* margin: -1.5rem; */
`

// const size = {
//   medium: '650px',
// }
// const device = {
//   medium: `(min-width: ${size.medium})`,
// }

const ResultText = styled(Text)`
  font-size: ${props => (props.small ? '2.6rem' : '4rem')};
  line-height: 1;
  width: 75%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
  padding-bottom: 0.7rem;

  /* @media (max-width: 449px) {
    font-size: 2.8rem;
  } */
`

const SelectedText = styled(Text)`
  margin-top: 0.2rem;
  font-size: ${props => (props.small ? '1.4rem' : '1.6rem')};
  line-height: 1;
  color: rgba(255, 255, 255, 0.8);

  /* @media (max-width: 449px) {
    font-size: 1.4rem;
  } */
`

const HomeHeading = styled(Heading)`
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.2;
`

const TurntableBox = styled(Box)`
  position: relative;
`

const ResultBox = styled(Box)`
  position: absolute;
  z-index: 10;
  width: calc(100% - 2rem);
  height: calc(100% - 2rem);
  overflow: hidden;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  align-items: center;
  justify-content: center;
`

const ResultModal = styled(Box)`
  position: absolute;
  width: 100%;
  height: 70%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  /* background-color: rgba(225, 225, 225, 0.7); */
  background-color: rgba(34, 34, 34, 0.8);
  padding-bottom: 0.5rem;
`

const ActionBox = styled(Box)`
  width: ${props => (props.small ? '15rem' : '20rem')};
  /* @media (max-width: 449px) {
    width: 15rem;
  } */
`

const CirclePlaceholder = styled(Box)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid ${props => props.theme.global.colors.greyBg};
  align-items: center;
  justify-content: center;
  margin: 1rem;
`

const EmbWheel = ({
  mute,
  result,
  resultIndex,
  turntable,
  turntableSize,
  tooSmall,
  choices,
  history,
  allResultsOpen,
  resetWord,
  title,
  confetti,
  color: textColor,
  showLogo,
  initialChoices,
  changeState,
}) => {
  const hideChoice = () => {
    const fChoicesIndexes = []
    for (let i = 0; i < choices.length; i++) {
      if (choices[i].filtered === false) {
        fChoicesIndexes.push(i)
      }
    }
    if (resultIndex > -1) {
      const index = fChoicesIndexes[resultIndex]
      let newChoices = choices.slice(0)
      newChoices[index].filtered = true
      changeState({
        choices: newChoices.slice(0),
        resultIndex: -1,
        turntable: null,
      })
    }
    const newHistory = history.slice(0)
    newHistory.push({ name: result, type: 'HIDE' }) //type 0: done, type 1: hide, type 2: count
    changeState({
      history: newHistory,
      result: '',
    })
  }

  const addCount = () => {
    const fChoicesIndexes = []
    for (let i = 0; i < choices.length; i++) {
      if (choices[i].filtered === false) {
        fChoicesIndexes.push(i)
      }
    }
    if (resultIndex > -1) {
      const index = fChoicesIndexes[resultIndex]
      let newChoices = choices.slice(0)
      const count = newChoices[index].count
      newChoices[index].count = count + 1
      changeState({
        choices: newChoices.slice(0),
        resultIndex: -1,
      })
    }
    const newHistory = history.slice(0)
    newHistory.push({ name: result, type: 'ADD' }) //type 0: done, type 1: hide, type 2: add
    changeState({
      history: newHistory,
      result: '',
    })
  }

  const againAction = () => {
    const newHistory = history.slice(0)
    newHistory.push({ name: result, type: 'DONE' }) //type 0: done, type 1: hide, type 2: count
    changeState({
      history: newHistory,
      result: '',
    })
  }

  const resetAction = () => {
    const resettedChoices = initialChoices.slice(0)
    changeState({
      turntable: null,
      choices: resettedChoices,
      result: '',
      resultIndex: -1,
      tooSmall: false,
      history: [],
      allResultsOpen: false,
      resetWord: 'Resetting',
    })
    setTimeout(() => {
      changeState({ resetWord: 'Reset' })
    }, 1000)
  }

  const availableChoices = choices.filter(c => c.filtered === false)
  return (
    <Measure
      bounds
      onResize={contentRect => {
        let size = 300
        const width = contentRect.bounds.width
        const occupiedSpace = !!title ? 70 : 20
        const height = contentRect.bounds.height - occupiedSpace - 20 // mute actions those and padding
        if (height < width) {
          size = height
        } else {
          size = width
        }
        if (size < 300) {
          changeState({ tooSmall: true })
          return
        } else {
          changeState({ tooSmall: false })
        }
        const maxWidth = 1200
        // const reference = isMobile ? 350 : maxWidth
        if (size > maxWidth) {
          changeState({ turntableSize: maxWidth, turntable: null })
          // setTurntableSize(maxWidth)
        } else if (size !== 0) {
          changeState({ turntableSize: size, turntable: null })
          // setTurntableSize(size)
        } else if (size === 0) {
          // const tempWidth = isMobile ? 300 : maxWidth
          changeState({ turntableSize: 300, turntable: null })
          // setTimeout(() => , 50)
        }
        // changeState({ dimensions: contentRect.bounds })
      }}
    >
      {({ measureRef }) => (
        <Container
          ref={measureRef}
          align="center"
          justify="center"
          flex={true}
          textColor={textColor}
          // background={bgColor}
          // direction={isMobile ? 'column' : 'row'}
        >
          {confetti && <Confetti active={!tooSmall && result} />}
          {!!title && (
            <Box width={`${turntableSize}px`} align="stretch">
              <Title>{title}</Title>
            </Box>
          )}

          <TurntableBox
            alignSelf="center"
            height={`${turntableSize}px`}
            width={`${turntableSize}px`}
            // width={isMobile ? `100%` : '50%'}
            align="center"
            justify="center"
          >
            {!tooSmall && turntable}
            {!tooSmall && result && (
              <ResultBox>
                <ResultModal align="center" justify="evenly">
                  <Box align="center" alignSelf="stretch">
                    <ResultText
                      weight="bold"
                      small={turntableSize < 465}
                      textAlign="center"
                    >
                      {result}
                    </ResultText>
                    <SelectedText small={turntableSize < 465}>
                      selected
                    </SelectedText>
                  </Box>
                  <Box>
                    {availableChoices.length > 0 && (
                      <ActionBox
                        direction="row"
                        justify="between"
                        width="15rem"
                        small={turntableSize < 465}
                      >
                        <ActionButton
                          label="Hide"
                          icon={<Hide color="white" size="26px" />}
                          background="secondary"
                          onClick={hideChoice}
                          small={turntableSize < 465}
                        />
                        <ActionButton
                          label="Count"
                          icon={
                            <Text
                              color="white"
                              size="1.8rem"
                              weight={700}
                              margin={{ top: '-1px' }}
                            >
                              +1
                            </Text>
                          }
                          background="secondary"
                          onClick={addCount}
                          small={turntableSize < 465}
                        />
                      </ActionBox>
                    )}
                    <ActionBox justify="center" small={turntableSize < 465}>
                      <ActionButton
                        label="Again"
                        icon={<Refresh color="secondary" size="26px" />}
                        background="white"
                        onClick={againAction}
                        small={turntableSize < 465}
                      />
                    </ActionBox>
                  </Box>
                </ResultModal>
              </ResultBox>
            )}
            {!tooSmall && allResultsOpen && (
              <AllResults
                history={history}
                choices={choices}
                turntableSize={turntableSize}
                showLogo={showLogo}
              />
            )}
            {tooSmall && (
              <CirclePlaceholder>
                <Text color="blackText" textAlign="center">
                  Size is too small
                </Text>
                <Text color="blackText" textAlign="center" size="14px">
                  (Width >=320px)
                </Text>
                <Text color="blackText" textAlign="center" size="14px">
                  (Height >=400px)
                </Text>
              </CirclePlaceholder>
            )}
          </TurntableBox>

          <Box
            direction="row"
            justify="between"
            width={`${turntableSize}px`}
            align="center"
            pad={{ horizontal: '10px' }}
            margin={{ bottom: '10px' }}
          >
            <Box
              background="reject"
              pad={{ horizontal: '14px', vertical: '3px' }}
              onClick={resetAction}
              border={{
                color: 'white',
                size: '1px',
                style: 'solid',
                side: 'all',
              }}
            >
              <Text color="white" size="15px">
                {resetWord}
              </Text>
            </Box>
            {showLogo && (
              <Box margin={{ horizontal: 'auto' }} pad={{ horizontal: '10px' }}>
                <LinkUrl
                  href="https://pickerwheel.com/"
                  target="_blank"
                  alt="Picker Wheel Site"
                >
                  <Box
                    height="100%"
                    direction="row"
                    align="center"
                    gap="5px"
                    justify="center"
                  >
                    <Box width="20px">
                      <Image
                        src={LogoImage}
                        fit="contain"
                        alt="pickerwheel.com"
                        margin="0"
                      />
                    </Box>
                    <HomeHeading
                      color="inherit"
                      textAlign="center"
                      level={2}
                      margin={{ vertical: '0px' }}
                    >
                      PickerWheel.com
                    </HomeHeading>
                  </Box>
                </LinkUrl>
              </Box>
            )}
            <Box direction="row" gap="20px">
              <Box
                onClick={() => {
                  changeState({
                    mute: !mute,
                  })
                  changeState({ turntable: null })
                }}
              >
                {mute ? (
                  <VolumeMute color="currentColor" size="24px" />
                ) : (
                  <Volume color="currentColor" size="24px" />
                )}
              </Box>

              <Box
                onClick={() => {
                  changeState({
                    allResultsOpen: !allResultsOpen,
                  })
                }}
              >
                {!allResultsOpen ? (
                  <History color="currentColor" size="24px" />
                ) : (
                  <Close color="currentColor" size="24px" />
                )}
              </Box>
            </Box>
          </Box>
        </Container>
      )}
    </Measure>
  )
}

export default EmbWheel
